export { default } from './platform-page-onboarding';
